/**
 * SMS Checkbox Utility
 */

import { FieldEntityProps } from '../types';

interface SmsCheckboxResult {
  type: 'checkbox';
  field: FieldEntityProps | undefined;
}

/**
 * Finds the SMS opt-in checkbox field from fields array.
 *
 * @param fields - Array of field entities to search
 * @returns Object containing field type and the SMS field (if found)
 *
 * @example
 * const smsCheckbox = getSmsCheckbox(fields);
 * if (smsCheckbox.field) {
 *   // Render SMS checkbox
 * }
 */
export const getSmsCheckbox = (
  fields: FieldEntityProps[],
): SmsCheckboxResult => {
  const smsCheckbox = fields.find(
    (field) => field.parameterName === 'sms_opt_in',
  );
  return {
    type: 'checkbox',
    field: smsCheckbox,
  };
};
